import { useQuery } from '@tanstack/react-query';
import { login } from 'api/auth.service';
import { useToast } from 'hooks/ui';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { setCurrentUser } from 'store/user.store';

export const useAdminGetCurrent = () => {
  const navigate = useNavigate();
  const [initialLoad, setInitialLoad] = useState<boolean>(true);
  const toast = useToast();

  const {
    isLoading,
    isFetching,
    data: user,
  } = useQuery(['auth'], login, {
    retry: 1,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    select: (data) => data,
    onSuccess: (data) => {
      setCurrentUser(data);
      if (initialLoad) {
        if (data.role === 'GUEST') {
          toast.warning(
            `Hi, ${data.firstName}! Seems like you don't have an access here. Please contact your local super admin. `,
          );
        } else {
          toast.success(`Welcome back, ${data.firstName}!`);
        }

        setInitialLoad(false);
      }
    },
    onError: (error: any) => {
      setCurrentUser(null);
      toast.error(
        `Something went wrong while authenticating. ${error.message}`,
      );
      navigate('/login');
    },
  });

  return { isLoading: isLoading || isFetching, user };
};
